import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Select} from 'antd';
import React from 'react';

import {CommonErrors} from '../../../../constants/Common';
import FilteredUnit from '../../../../constants/FilteredUnit';
import InformativeText from '../../../../constants/InformativeText';
import NumberInput from '../../../../shared/NumberInput';
import useJSONStore from '../../../../store/StaticJson/jsonStore';
import RegEx from '../../../../utils/FormUtils/RegEx';
import {upstreamKey, upstreamLabel} from '../../Constants/IP/UpstreamKeyLabel';
import {filterSelectOptions} from '../commonFunctions';

const UpstreamList: React.FC<{
  type: 'up' | 'down';
  name?: any;
  formSelectedCountry: string;
  modeOfTransport: any;
}> = ({type, name, formSelectedCountry, modeOfTransport}) => {
  const colSpan = 12;
  const frequency = useJSONStore.getState().frequency;
  const upSuppInfo = InformativeText?.IP?.supplyChain?.upstream;
  const downSuppInfo = InformativeText?.IP?.supplyChain?.downStream;

  // const {selectedCountry} = useContext(SelectedCountryContext);

  return (
    <>
      <Col className="gutter-row" span={colSpan}>
        <Form.Item
          name={[name, upstreamKey.FREQUENCY_TRANSPORT]}
          rules={[
            {
              required: true,
              message: CommonErrors.mandatory(upstreamLabel.FREQUENCY_TRANSPORT)
            }
          ]}
          label={upstreamLabel.FREQUENCY_TRANSPORT}
          labelCol={{span: 24}}
        >
          <Select
            className="select"
            placeholder={`Choose ${upstreamLabel.FREQUENCY_TRANSPORT}`}
            options={frequency}
          />
        </Form.Item>
      </Col>
      <Col className="gutter-row" span={colSpan}>
        <Form.Item
          name={[name, upstreamKey.FREQUENCY_NUM]}
          rules={[
            {
              required: true,
              message: CommonErrors.mandatory(upstreamLabel.FREQUENCY_NUM)
            },
            {
              pattern: RegEx.noZeroNoNegative,
              message: 'Please enter non decimal value more than 0'
            }
          ]}
          label={upstreamLabel.FREQUENCY_NUM}
          labelCol={{span: 24}}
          initialValue={undefined}
        >
          <NumberInput
            className="input"
            placeholder={`Enter ${upstreamLabel.FREQUENCY_NUM}`}
          />
        </Form.Item>
      </Col>
      <Col className="gutter-row" span={colSpan}>
        <Form.Item
          name={[name, upstreamKey.MODE]}
          rules={[
            {
              required: true,
              message: CommonErrors.mandatory(upstreamLabel.MODE)
            }
          ]}
          label={upstreamLabel.MODE}
          labelCol={{span: 24}}
        >
          <Select
            className="select"
            placeholder={`Choose ${upstreamLabel.MODE}`}
            options={modeOfTransport}
            showSearch
            filterOption={filterSelectOptions}
            // onChange={(e) => {
            //   setModeOfTransport(e);
            // }}
          />
        </Form.Item>
      </Col>
      {/* {(modeOfTransport === 20 || modeOfTransport === 21) && (
    <Col className="gutter-row" span={colSpan}>
      <Form.Item
        name={upstreamKey.CLASS_OF_TRAVEL}
        rules={[]}
        label={upstreamLabel.CLASS_OF_TRAVEL}
        labelCol={{span: 24}}
      >
        <Select
          className="select"
          placeholder={upstreamLabel.CLASS_OF_TRAVEL}
          options={classOfTravel}
          onChange={(e) => {
            setModeOfTransport(e);
          }}
        />
      </Form.Item>
    </Col>
  )} */}
      <Col className="gutter-row" span={colSpan}>
        <Form.Item
          name={[name, upstreamKey.QUANTITY]}
          rules={[
            {
              required: true,
              message: CommonErrors.mandatory(upstreamLabel.QUANTITY)
            },
            {
              pattern: RegEx.noZeroNoNegative,
              message: 'Please enter non decimal value more than 0'
            }
          ]}
          label={upstreamLabel.QUANTITY}
          labelCol={{span: 24}}
        >
          <NumberInput
            addonAfter={FilteredUnit(formSelectedCountry).weight}
            className="input"
            placeholder={`Enter ${upstreamLabel.QUANTITY}`}
          />
        </Form.Item>
      </Col>
      <Col className="gutter-row" span={colSpan}>
        <Form.Item
          name={[name, upstreamKey.DISTANCE_TRAVELLED]}
          rules={[
            {
              required: true,
              message: CommonErrors.mandatory(upstreamLabel.DISTANCE_TRAVELLED)
            },
            {
              pattern: RegEx.noZeroNoNegative,
              message: 'Please enter non decimal value more than 0'
            }
          ]}
          label={upstreamLabel.DISTANCE_TRAVELLED}
          labelCol={{span: 24}}
          tooltip={{
            icon: <InfoCircleOutlined />,
            title:
              type === 'up'
                ? upSuppInfo?.distanceTravelled
                : downSuppInfo?.distanceTravelled
          }}
        >
          <NumberInput
            addonAfter={FilteredUnit(formSelectedCountry).distance}
            className="input"
            placeholder={`Enter ${upstreamLabel.DISTANCE_TRAVELLED}`}
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default UpstreamList;
